<script context="module"></script>

<script>import * as d3 from "d3";
import { layoutRanges } from "./projection-helpers.js";
export let tag = "";
export let xScale;
export let height = 10;
export let defaultFill;
export let strokes;
export let data;
export let size;
const startLevel = 0;
const spacing = 0;
const y = (levelIndex) => startLevel + levelIndex * (height + spacing);
$:
  layout = layoutRanges(data);
$: {
  size = y(layout.count - 1) + height - startLevel;
}
const getStroke = (index, tag2) => strokes[tag2].stroke[index % strokes[tag2].stroke.length];
</script>

<g
	class="tag-projection {tag}"
	stroke="none"
	fill={defaultFill?.formatHex()}
	fill-opacity={defaultFill?.opacity}
>
	{#each data as series, i}
		{#each series as datum}
			<rect
				stroke="none"
				y={y(layout.levels[i])}
				{height}
				class={datum.tag}
				x={xScale(datum.start)}
				width={xScale(datum.end) - xScale(datum.start)}
				fill={getStroke(i, datum.tag).color.formatHex()}
				fill-opacity={getStroke(i, datum.tag).color.opacity}
			/>
		{/each}
	{/each}
</g>

<style>
	g.tag-projection :global(rect._untagged_) {
		display: none;
	}
</style>
